"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeImpl = void 0;
const tslib_1 = require("tslib");
/// <reference path="Tree.d.ts" />
const $ = require("jquery");
const Utilities_1 = require("../../javascript/Utilities");
const QueryString_1 = require("../../javascript/QueryString");
var TreePrivateDataKeys;
(function (TreePrivateDataKeys) {
    TreePrivateDataKeys[TreePrivateDataKeys["TriggerOnObjectContextMenuOnSelect"] = 0] = "TriggerOnObjectContextMenuOnSelect";
    TreePrivateDataKeys[TreePrivateDataKeys["EventObjectContextMenuSave"] = 1] = "EventObjectContextMenuSave";
    TreePrivateDataKeys[TreePrivateDataKeys["InitialDataBind"] = 2] = "InitialDataBind";
    TreePrivateDataKeys[TreePrivateDataKeys["IsInitialized"] = 3] = "IsInitialized";
})(TreePrivateDataKeys || (TreePrivateDataKeys = {}));
class TreeImpl {
    static initAsync($elem, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                let synData = TreeImpl.getData($elem);
                if (synData)
                    reject("Tree already initialized");
                else {
                    if (Utilities_1.synUtil.isHDScreen)
                        $elem.addClass("HDScreen");
                    synData = $.extend({}, TreeImpl.DefaultOptions, options);
                    TreeImpl.setData($elem, synData);
                    TreeImpl.setPrivateData($elem, TreePrivateDataKeys.TriggerOnObjectContextMenuOnSelect, false);
                    $elem
                        .addClass("initializing")
                        .kendoTreeView({
                        dataTextField: "name",
                        dataImageUrlField: "iconUrl",
                        dataBound: (e) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            const initalDataBind = TreeImpl.getPrivateData($elem, TreePrivateDataKeys.InitialDataBind);
                            const tv = $elem.data("kendoTreeView");
                            if (!initalDataBind) {
                                TreeImpl.setPrivateData($elem, TreePrivateDataKeys.InitialDataBind, true);
                                if (synData.initialSelection === "root") {
                                    const root = TreeImpl.getRootNode($elem);
                                    root.set("selected", true);
                                }
                                else if (synData.initialSelection !== false)
                                    yield TreeImpl.trySetPathAsync($elem, synData.initialSelection);
                                if (synData.expandInitiallySelectedNode === true)
                                    yield TreeImpl.expandCoreAsync(tv, tv.dataItem(tv.select()));
                                else if (TreeImpl.isRootNodeSelected($elem) && synData.expandInitiallySelectedNode === "OnlyRootNode")
                                    yield TreeImpl.expandCoreAsync(tv, tv.dataItem(tv.select()));
                                $elem.removeClass("initializing");
                                resolve();
                                TreeImpl.setPrivateData($elem, TreePrivateDataKeys.IsInitialized, true);
                            }
                            let nodes = $elem.find(".k-in");
                            if (Utilities_1.synUtil.clientDeviceClass !== "desktop")
                                TreeImpl.makeStackList($elem);
                            nodes.each((_idx, elem) => {
                                const $node = $(elem);
                                if (Utilities_1.synUtil.clientDeviceClass !== "desktop") {
                                    $node.find(".k-icon")
                                        .off("click")
                                        .on("click", (e) => { e.stopPropagation(); });
                                }
                                $node
                                    .off("click")
                                    .on("click", () => {
                                    // to prevent reloading when treenode is currently disabled
                                    if ($node.closest(".k-item").is(".k-state-disabled"))
                                        return false;
                                    let dataItem = tv.dataItem($node);
                                    const triggerOnObjectContextMenuOnSelect = TreeImpl.getPrivateData($elem, TreePrivateDataKeys.TriggerOnObjectContextMenuOnSelect);
                                    if (triggerOnObjectContextMenuOnSelect) {
                                        if (dataItem.get("selected")) {
                                            const eventObjectContextMenuSave = TreeImpl.getPrivateData($elem, TreePrivateDataKeys.EventObjectContextMenuSave);
                                            TreeImpl.setPrivateData($elem, TreePrivateDataKeys.TriggerOnObjectContextMenuOnSelect, false);
                                            $elem.trigger("onObjectContextMenu", [eventObjectContextMenuSave]);
                                        }
                                    }
                                });
                            });
                        }),
                        dataSource: new kendo.data.HierarchicalDataSource({
                            transport: {
                                read: (options) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    const nodes = yield TreeImpl.getNodesAsync($elem, options.data.id);
                                    options.success(nodes);
                                })
                            },
                            schema: {
                                model: {
                                    id: "id",
                                    hasChildren: "hasChildren"
                                }
                            }
                        }),
                        select(e) {
                            const node = $elem.data("kendoTreeView").dataItem(e.node);
                            if (node === null || node === void 0 ? void 0 : node.id) {
                                let parentId = undefined;
                                if (node.parentNode())
                                    parentId = node.parentNode().get("instanceId");
                                $elem.trigger("nodeSelected", {
                                    selectedId: node.get("instanceId"),
                                    selectedParentId: parentId,
                                    path: TreeImpl.fixPath(node.get("id"))
                                });
                                const triggerOnObjectContextMenuOnSelect = TreeImpl.getPrivateData($elem, TreePrivateDataKeys.TriggerOnObjectContextMenuOnSelect);
                                if (triggerOnObjectContextMenuOnSelect) {
                                    // Hier kommt man durch, wenn man auf einen NICHT SELEKTIERTEN Knoten einen Rechtsklick macht.
                                    TreeImpl.setPrivateData($elem, TreePrivateDataKeys.TriggerOnObjectContextMenuOnSelect, false);
                                    const eventObjectContextMenuSave = TreeImpl.getPrivateData($elem, TreePrivateDataKeys.EventObjectContextMenuSave);
                                    $elem.trigger("onObjectContextMenu", [eventObjectContextMenuSave]);
                                }
                            }
                        },
                        messages: {
                            loading: Utilities_1.synUtil.Strings.getValue("synwait")
                        }
                    });
                    $elem
                        .on("contextmenu", (evt) => {
                        if (Utilities_1.synUtil.clientDeviceClass === "desktop") {
                            // Das ContextMenu gibt es derzeit nur im Desktop. Begründung siehe List.ts.
                            let activateContextMenu = Utilities_1.synUtil.Configs.getValue("webtoolkitactivatecontextmenu", "Y");
                            if (activateContextMenu === "Y") {
                                if ($(evt.target).closest(".k-in").length) {
                                    // Da wurde auf Items im Tree "rechtsgeklickt"
                                    // Sicherstellen, dass dieses Item vor der Anzeige des ContextMenus zuvor selektiert wird.
                                    evt.preventDefault();
                                    TreeImpl.setPrivateData($elem, TreePrivateDataKeys.TriggerOnObjectContextMenuOnSelect, true);
                                    TreeImpl.setPrivateData($elem, TreePrivateDataKeys.EventObjectContextMenuSave, evt);
                                    $(evt.target).closest(".k-in").trigger("click");
                                }
                                else {
                                    // Da wurde in den freien Raum "rechtsgeklickt"
                                    evt.preventDefault();
                                }
                                $elem.trigger("onObjectContextMenu", [evt]);
                            }
                        }
                    })
                        .on("click", (evt) => {
                        const $node = $(evt.target).closest(".k-in");
                        if ($node.length) {
                            const node = $elem.data("kendoTreeView").dataItem($node);
                            if (node.get("selected")) {
                                if (!TreeImpl.isFocused($elem) && evt.which === 1 /* Left mouse button */)
                                    $elem.trigger("nodeRefocusRequested");
                                else
                                    $elem.trigger("focusedNodeClick");
                            }
                        }
                    })
                        .addClass("synTree");
                }
            });
        });
    }
    static destroy($elem) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            if ($this.data("kendoTreeView"))
                $this.data("kendoTreeView").destroy();
            Object.keys(TreePrivateDataKeys)
                .filter(k => !isNaN(parseInt(k, 10)))
                .map(k => parseInt(k, 10))
                .forEach((key) => { TreeImpl.deletePrivateData($elem, key); });
            $this
                .removeData("synTree")
                .removeClass("HDScreen synTree")
                .off("nodeSelected")
                .off("nodeFiltering")
                .html("");
        });
    }
    static isInitialized($elem) {
        return TreeImpl.getPrivateData($elem, TreePrivateDataKeys.IsInitialized) === true;
    }
    static getPath($elem) {
        const tv = $elem.data("kendoTreeView");
        if (!tv)
            return undefined;
        const node = tv.dataItem(tv.select());
        if (!node)
            return undefined;
        return TreeImpl.fixPath(node.get("id"));
    }
    static trySetPathAsync($elem, path) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (TreeImpl.getPath($elem) === path)
                return "PathUnchanged";
            const treeView = $elem.data("kendoTreeView");
            const rootNode = TreeImpl.getRootNode($elem);
            let pathArr = path.split("/");
            pathArr.splice(0, 0, TreeImpl.getRootNodeId($elem));
            return yield TreeImpl.trySetPathCoreAsync(treeView, rootNode, pathArr);
        });
    }
    static unselect($elem) {
        return $elem.each((_idx, elem) => {
            const $this = $(elem);
            const tv = $this.data("kendoTreeView");
            if (tv)
                tv.select($());
        });
    }
    static refreshAsync($elem, fullRefresh) {
        const tv = $elem.data("kendoTreeView");
        return new Promise((resolve) => {
            if (!TreeImpl.isInitialized($elem))
                resolve();
            else if (fullRefresh) {
                const path = TreeImpl.getPath($elem);
                tv.one("dataBound", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    yield TreeImpl.trySetPathAsync($elem, path);
                    resolve();
                }));
                tv.dataSource.read();
            }
            else {
                let node = tv.dataItem(tv.select());
                if (node) {
                    node.loaded(false);
                    node.load();
                    TreeImpl.waitForNodeLoadedAsync(node)
                        .then(() => { resolve(); });
                }
            }
        });
    }
    static getRootNodeId($elem) {
        const rootNode = TreeImpl.getRootNode($elem);
        return rootNode.get("instanceId");
    }
    static getSelectedId($elem) {
        const tv = $elem.data("kendoTreeView");
        if (!tv)
            return undefined;
        const node = tv.dataItem(tv.select());
        if (!node)
            return undefined;
        return node.get("instanceId");
    }
    static getSelectedParentId($elem) {
        const tv = $elem.data("kendoTreeView");
        if (!tv)
            return undefined;
        const node = tv.dataItem(tv.select());
        if (!node)
            return undefined;
        const parent = node.parentNode();
        if (!parent)
            return undefined;
        return parent.get("instanceId");
    }
    static isRootNodeSelected($elem) {
        const rootNodeId = TreeImpl.getRootNodeId($elem);
        if (!rootNodeId)
            return false;
        return rootNodeId === TreeImpl.getSelectedId($elem);
    }
    static update($elem, instanceArray) {
        return $elem.each((_idx, elem) => {
            const iconSize = Utilities_1.synUtil.isHDScreen ? 32 : 16;
            const $this = $(elem);
            if (TreeImpl.isInitialized($this)) {
                const tv = $this.data("kendoTreeView");
                const mapInstances = {};
                instanceArray.forEach((inst) => { mapInstances[inst.id.valueAsString] = inst; });
                $this.find("li.k-item")
                    .toArray()
                    .map(li => tv.dataItem(li))
                    .forEach((node) => {
                    const inst = mapInstances[node.get("instanceId")];
                    if (inst) {
                        node.set("iconUrl", Utilities_1.synUtil.getWSUrl("Icon") + inst["icon"].value + "/" + iconSize);
                        node.set("name", TreeImpl.getTreeNodeText(inst["treename"].value));
                    }
                });
            }
        });
    }
    static linkAsync($elem, instanceArray, parent) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!TreeImpl.isInitialized($elem))
                return;
            const tv = $elem.data("kendoTreeView");
            // Get matching tree nodes
            const matchingNodes = $elem
                .find("li[role='treeitem']")
                .toArray()
                .map((nodeElem) => tv.dataItem(nodeElem))
                .filter(node => node.get("instanceId") === parent.id.value);
            if (matchingNodes.length) {
                let childrenLinkedToSelectedNode = false;
                const selectedNode = tv.dataItem(tv.select());
                const selectedId = selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.id;
                let childNodes = yield TreeImpl.getNodesAsync($elem, matchingNodes[0].id);
                // We strictly just care for the ADDED nodes in instanceArray - if some childNodes have
                // been removed by someone else in the meantime, that's none of our business here.
                // linkAsync() promises to link nodes in instanceArray under all nodes matching parent's
                // id, nothing else.
                // First we create an array of all nodes returned by getNodesAsync() that appear in instanceArray
                let idMap = {};
                instanceArray.forEach((inst) => { idMap[inst.id.valueAsString] = true; });
                childNodes = childNodes.filter(n => idMap[n.instanceId]);
                // Now we link all those childNodes under all parentNodes macthing parent's id
                for (let curNode of matchingNodes) {
                    if (curNode.id === selectedId)
                        childrenLinkedToSelectedNode = true;
                    // If the node hasn't been loaded, we need not do anything here, as expanding would fetch the
                    // (new) children anyway
                    if (!curNode.loaded())
                        continue;
                    else {
                        // We won't observe the sort order of child nodes, as this is determined server-side.
                        // Different tree nodes for the same parent id might have different snapshots in time
                        // of the childnodes, as they might have been expanded at different moments, so we need
                        // to check for each parent node.
                        const curChildNodes = TreeImpl.getChildNodes(curNode, false);
                        let childNodeIdMap = {};
                        curChildNodes.forEach((cn) => { childNodeIdMap[cn.get("instanceId")] = true; });
                        childNodes.forEach((cn) => {
                            if (!childNodeIdMap[cn.instanceId]) {
                                // We need to fix the id since it depends on the parent's path
                                let copy = $.extend({}, cn);
                                copy.id = TreeImpl.buildParentPath(curNode) + "/" + copy.instanceId;
                                curNode.append(copy);
                            }
                        });
                    }
                }
                // If currently selected node has had children linked during this operation, make sure
                // it's expanded afterwards, so the changes can be seen.
                if (childrenLinkedToSelectedNode)
                    yield TreeImpl.expandCoreAsync(tv, selectedNode);
            }
        });
    }
    static unlinkAsync($elem, instanceArray, parent) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!TreeImpl.isInitialized($elem))
                return;
            const tv = $elem.data("kendoTreeView");
            // Get matching tree nodes
            const matchingNodes = $elem
                .find("li[role='treeitem']")
                .toArray()
                .map((nodeElem) => tv.dataItem(nodeElem))
                .filter(node => !parent || node.get("instanceId") === parent.id.value);
            if (matchingNodes.length) {
                let childNodes = yield TreeImpl.getNodesAsync($elem, matchingNodes[0].id);
                // We strictly just care for the REMOVED nodes in instanceArray - if some childNodes have
                // been added by someone else in the meantime, that's none of our business here.
                // unlinkAsync() promises to unlink nodes in instanceArray under all nodes matching parent's
                // id, nothing else.
                // First we create an array of ids of all nodes NOT returned by getNodesAsync() that appear in instanceArray
                let childNodeMap = {};
                childNodes.forEach((cn) => { childNodeMap[cn.instanceId] = true; });
                let removeIdMap = {};
                instanceArray
                    .filter(inst => !childNodeMap[inst.id.valueAsString])
                    .map(inst => inst.id.value)
                    .forEach(id => { removeIdMap[id] = true; });
                // Now we unlink all those childNodes under all parentNodes macthing parent's id
                const selectedNode = tv.dataItem(tv.select());
                let newNodeToSelect = selectedNode;
                for (let curNode of matchingNodes) {
                    // If the node hasn't been loaded, we need not do anything here, as expanding would fetch the 
                    // (new) children anyway
                    if (!curNode.loaded())
                        continue;
                    else {
                        const curChildNodes = TreeImpl.getChildNodes(curNode, false);
                        curChildNodes
                            .forEach((node, nodeIdx) => {
                            if (removeIdMap[node.get("instanceId")]) {
                                // We have to check if a child node of curNode is currently selected.
                                // If so, we have to select a new node with the following algorithm:
                                // 1. Try to select a predecessor sibling node of the currently selected node, make sure
                                //    it has not been deleted.
                                // 2. Else, try to select a successor sibling node of the currently selected node. Later
                                //    iterations of this loop might deleted said successor node, in which case the
                                //    algorithm starts from the top
                                // 3. Lastly, select the parent node of the currently selected node.
                                if (selectedNode) {
                                    if (node.get("id") === selectedNode.get("id")) {
                                        let predecessorSelected = false;
                                        for (let checkIdx = nodeIdx; checkIdx >= 0; --checkIdx) {
                                            const curInstanceId = curChildNodes[checkIdx].get("instanceId");
                                            if (!removeIdMap[curInstanceId]) {
                                                newNodeToSelect = curChildNodes[checkIdx];
                                                predecessorSelected = true;
                                                break;
                                            }
                                        }
                                        if (!predecessorSelected) {
                                            if (nodeIdx < curChildNodes.length - 1)
                                                newNodeToSelect = curChildNodes[nodeIdx + 1];
                                            else
                                                newNodeToSelect = node.parentNode();
                                        }
                                    }
                                }
                                tv.remove(tv.findByUid(node.uid));
                            }
                        });
                    }
                }
                if (newNodeToSelect && newNodeToSelect.get("id") !== selectedNode.get("id")) {
                    newNodeToSelect.set("selected", true);
                    let parentId = undefined;
                    if (newNodeToSelect.parentNode())
                        parentId = newNodeToSelect.parentNode().get("instanceId");
                    $elem.trigger("nodeSelected", {
                        selectedId: newNodeToSelect.get("instanceId"),
                        selectedParentId: parentId,
                        path: TreeImpl.fixPath(newNodeToSelect.get("id"))
                    });
                }
            }
        });
    }
    static focus($elem, focused) {
        return $elem.toggleClass("unfocused", !focused);
    }
    static isFocused($elem) {
        return !$elem.hasClass("unfocused");
    }
    static tryOpenChildNodeAsync($elem, childNodeId) {
        const tv = $elem.data("kendoTreeView");
        return new Promise((resolve) => {
            let node = tv.dataItem(tv.select());
            if (!node)
                resolve(false);
            else {
                node.loaded(false);
                node.load();
                TreeImpl.waitForNodeLoadedAsync(node)
                    .then(() => {
                    const matching = TreeImpl.getChildNodes(node, false)
                        .filter(n => n.instanceId === childNodeId);
                    if (matching.length === 0)
                        resolve(false);
                    else {
                        tv.findByUid(matching[0].uid).find(".k-in").trigger("click");
                        resolve(true);
                    }
                });
            }
        });
    }
    //#region Helpers
    static getNodesAsync($elem, parentNodeId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const synData = TreeImpl.getData($elem);
            let qsMap = {};
            let url = Utilities_1.synUtil.getWSUrl("InstanceChildrenTree");
            if (parentNodeId) {
                const spl = parentNodeId.split("/");
                url += spl[spl.length - 1];
            }
            else {
                if (synData.rootNodeId)
                    qsMap["root"] = synData.rootNodeId;
                if (synData.initialSelection !== false && synData.initialSelection !== "root")
                    qsMap["path"] = synData.initialSelection;
            }
            const data = yield Utilities_1.synUtil.getAJAXDataAsync({
                url: url + QueryString_1.QueryString.toQueryString(qsMap)
            });
            let parentNode = undefined;
            if (parentNodeId)
                parentNode = $elem.data("kendoTreeView").dataSource.get(parentNodeId);
            $elem.trigger("nodeFiltering", [data]);
            return TreeImpl.prepareNodes(parentNode, data);
        });
    }
    static getRootNode($elem) {
        return $elem.data("kendoTreeView").dataItem($elem.find(".k-item:first"));
    }
    static trySetPathCoreAsync(treeView, curNode, pathArr) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            treeView.element.find(".k-item").each((_idx, elem) => {
                treeView.dataItem($(elem)).set("selected", false);
            });
            const curId = pathArr[0];
            pathArr.shift();
            if (curId !== curNode.get("instanceId")) {
                curNode.set("selected", true);
                return false;
            }
            else {
                if (pathArr.length === 0) {
                    curNode.set("selected", true);
                    return true;
                }
                else {
                    yield TreeImpl.expandCoreAsync(treeView, curNode);
                    if (TreeImpl.getChildNodes(curNode, false).length === 0) {
                        curNode.set("selected", true);
                        return false;
                    }
                    else {
                        const matching = TreeImpl.getChildNodes(curNode, false)
                            .filter(n => n.instanceId === pathArr[0]);
                        if (matching.length === 0) {
                            curNode.set("selected", true);
                            return false;
                        }
                        else {
                            return yield TreeImpl.trySetPathCoreAsync(treeView, matching[0], pathArr);
                        }
                    }
                }
            }
        });
    }
    static expandCoreAsync(treeView, node) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                if (!node)
                    resolve();
                else if (node.loaded()) {
                    node.set("expanded", true);
                    resolve();
                }
                else {
                    treeView.dataSource.one("change", () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        yield TreeImpl.waitForNodeLoadedAsync(node);
                        resolve();
                    }));
                    node.set("expanded", true);
                }
            });
        });
    }
    static waitForNodeLoadedAsync(node) {
        return new Promise((resolve) => {
            const intervalId = window.setInterval(() => {
                if (node.loaded()) {
                    window.clearInterval(intervalId);
                    resolve();
                }
            }, 20);
        });
    }
    static getChildNodes(parent, recursive) {
        let children = [];
        let queue = [parent];
        while (queue.length) {
            const curParent = queue.shift();
            if (curParent.loaded()) {
                const curChildren = curParent.children.data().slice(0);
                children = children.concat(curChildren);
                if (recursive)
                    queue = queue.concat(curChildren);
            }
        }
        return children;
    }
    static prepareNodes(parentNode, childNodes) {
        const iconSize = Utilities_1.synUtil.isHDScreen ? 32 : 16;
        const parentPath = TreeImpl.buildParentPath(parentNode);
        return childNodes.map((n) => {
            return {
                iconUrl: Utilities_1.synUtil.getWSUrl("Icon") + n.iconId + "/" + iconSize,
                name: TreeImpl.getTreeNodeText(n.text),
                id: parentPath ? parentPath + "/" + n.id : n.id,
                instanceId: n.id,
            };
        });
    }
    static makeStackList($elem) {
        $elem.find("li.k-item").removeClass("actLevel").hide();
        $elem.find("li.k-item[aria-selected='true']").show();
        $elem.find("li.k-item[aria-selected='true']").parents().show();
        $elem.find("li.k-item[aria-selected='true'] > ul > li").show().addClass("actLevel");
    }
    static buildParentPath(node) {
        let pathArr = [];
        while (node) {
            pathArr.unshift(node.get("instanceId"));
            node = node.parentNode();
        }
        return pathArr.join("/");
    }
    static getTreeNodeText(nodeText) {
        return nodeText || "Error!";
    }
    static setData($elem, data) {
        $elem.data("synTree", data);
    }
    static getData($elem) {
        return $elem.data("synTree");
    }
    static setPrivateData($elem, key, data) {
        $elem.data(TreePrivateDataKeys[key], data);
    }
    static getPrivateData($elem, key) {
        return $elem.data(TreePrivateDataKeys[key]);
    }
    static deletePrivateData($elem, key) {
        $elem.removeData(TreePrivateDataKeys[key]);
    }
    // Internal path representation (including root) to external path representation (excluding root)
    static fixPath(path) {
        const arr = path.split("/");
        return arr.slice(1).join("/");
    }
}
exports.TreeImpl = TreeImpl;
/**
 * Contains all default values for option parameters not passed by the caller
 */
TreeImpl.DefaultOptions = {
    initialSelection: "root",
    expandInitiallySelectedNode: true
};
// Dispatcher code
(($) => {
    $.fn.synTree = function (method) {
        if (TreeImpl[method])
            return TreeImpl[method].apply(undefined, [this].concat(Array.prototype.slice.call(arguments, 1)));
        else if (typeof method === "object" || !method)
            return TreeImpl.initAsync(this, arguments[0]);
        else
            $.error("Method " + method + " does not exist on jQuery.synTree");
    };
})(jQuery);
